import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnValue,
  returnBlockValue,
  returnUserContent,
} from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  userContents,
} from '@/utils/op-types/store'

// components
import Input from '@/components/optypes/headlesss-components/Input'
import RadioSelect from '@/components/optypes/headlesss-components/Radio/RadioSelect'
import { RadioGroup } from '@headlessui/react'

const StupidBlock = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  // custom page settings
  const [getUserContents, setUserContents] = useAtom(userContents)

  return (
    <div>
      {/* example of returning value - content */}
      <div
        className={Classnames(
          'my-6 font-bold text-blue-700 px-12 py-6 rounded',
          {
            'bg-blue-200':
              returnBlockValue(
                'theme_option',
                'content',
                opBlocks[block],
                content
              ) == 'theme_1',
            'bg-green-200':
              returnBlockValue(
                'theme_option',
                'content',
                opBlocks[block],
                content
              ) == 'theme_2',
          }
        )}
      >
        {returnBlockValue('text', 'content', opBlocks[block], content)}

        <div className="pt-2">
          <Input
            className="bg-white text-black rounded py-2 px-4 border-2 border-black"
            blockId={id}
            contentKey="value"
            placeholder="placceeeeholdeerrrr"
            preventEnter={false}
            onEnter={() => {
              console.log('root enter')
            }}
            onFocus={() => {
              console.log('root focus fn')
            }}
            onBlur={() => {
              console.log('root blur fn')
            }}
          />
        </div>

        <div className="mt-4">
          <div className="mb-2">Radio option / selector</div>
          <RadioSelect blockId={id} contentKey="selected" className="space-y-3">
            {returnBlockValue(
              'radio_options',
              'content',
              opBlocks[block],
              content
            ).map((opt, index) => (
              <RadioGroup.Option
                key={opt.id}
                value={opt.option}
                className={({ checked, active }) => `
                  ${checked && 'bg-indigo-600 text-white outline-none'}
                  ${active && 'outline-none ring-2 ring-indigo-500'}
                  rounded py-2 px-4 shadow bg-white
                `}
              >
                {({ checked, active }) => (
                  <div className="font-bold">
                    {opt.option} | {opt.headline}
                  </div>
                )}
              </RadioGroup.Option>
            ))}
          </RadioSelect>
        </div>
      </div>
    </div>
  )
}

export default StupidBlock
